export enum LocalizationEvent {
    ChangeLanguage = 'Localization.ChangeLanguage',
}
